import { render, staticRenderFns } from "./DiamondWeights.vue?vue&type=template&id=bc1e663a&"
import script from "./DiamondWeights.vue?vue&type=script&lang=js&"
export * from "./DiamondWeights.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports